import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export const estadoAlumno = {
    Activo: 'ACT',
    Inscrito: 'INS',
    BajaTemporal: { Voluntaria: 'BT1', Especiales: 'BT2', NoInscrito: 'BT3' },
    BajaDefinitiva: {
        Voluntaria: 'BD1',
        Reprobacion: 'BD2',
        Especiales: 'BD3',
        excedeSemestres: 'BD4',
        NoInscrito: 'BD5',
        noCumpleRequisitos: 'BD6',
        alteracion: 'BD7',
    },
    Egresado: 'EGR',
    Titulado: 'TIT',
};

@Injectable({
    providedIn: 'root',
})
export class EstatusService {
    private estatus: { id: string; name: string }[] = [
        { id: 'ACT', name: 'Activo' },
        { id: 'INS', name: 'Inscrito' },
        { id: 'BT1', name: 'Baja temporal voluntaria' },
        { id: 'BT2', name: 'Baja temporal por adeudo de exámenes especiales' },
        { id: 'BT3', name: 'Baja temporal por no inscripción' },
        { id: 'BD1', name: 'Baja definitiva voluntaria' },
        {
            id: 'BD2',
            name: 'Baja definitiva por reprobación en primer semestre',
        },
        { id: 'BD3', name: 'Baja definitiva por examen especial reprobado' },
        {
            id: 'BD4',
            name: 'Baja definitiva por alcanzar el número máximo semestres permitido',
        },
        { id: 'BD5', name: 'Baja definitiva por no inscripción / Deserción' },
        {
            id: 'BD6',
            name: 'Baja definitiva por no cumplir con requisito de inscripción',
        },
        {
            id: 'BD7',
            name: 'Baja definitiva por alteración de documentos oficiales',
        },
        { id: 'BD8', name: 'Baja definitiva por translado' },
        { id: 'EGR', name: 'Egresado' },
        { id: 'TIT', name: 'Titulado' },
        { id: 'DES', name: 'Desconocido' },
    ];

    constructor() {}

    getStatus(): Observable<any[]> {
        return new Observable<any[]>((observer) => {
            observer.next(this.estatus);
        });
    }

    getEstatusAlumno(
        estatus: string
    ): Observable<{ id: string; name: string }> {
        return new Observable<any>((observer) => {
            observer.next(
                this.estatus.find((e) => e.id == (estatus ?? '')) ?? {
                    id: 'DES',
                    name: 'Desconocido',
                }
            );
        });
    }

    getEstatusAlumnoD(estatus: string): { id: string; name: string } {
        return (
            this.estatus.find((e) => e.id == (estatus ?? '')) ?? {
                id: 'DES',
                name: 'Desconocido',
            }
        );
    }

    esBajaTemporal(estado: string): boolean {
        return (
            estado === estadoAlumno.BajaTemporal.Especiales ||
            estado === estadoAlumno.BajaTemporal.NoInscrito ||
            estado === estadoAlumno.BajaTemporal.Voluntaria
        );
    }

    esBajaDefinitiva(estado: string): boolean {
        return (
            estado === estadoAlumno.BajaDefinitiva.Voluntaria ||
            estado === estadoAlumno.BajaDefinitiva.Especiales ||
            estado === estadoAlumno.BajaDefinitiva.Reprobacion ||
            estado === estadoAlumno.BajaDefinitiva.excedeSemestres ||
            estado === estadoAlumno.BajaDefinitiva.NoInscrito ||
            estado === estadoAlumno.BajaDefinitiva.noCumpleRequisitos ||
            estado === estadoAlumno.BajaDefinitiva.alteracion
        );
    }

    esBaja(estado: string) {
        return this.esBajaDefinitiva(estado) || this.esBajaTemporal(estado);
    }
}
